import React, { useState } from "react";
import CustomTabs from "components/tabs/customTab";
import { Send, Sparkles, Trophy } from "lucide-react";
import AwardStatusCard from "./AwardStatusCard";
import AwardCategoryCard from "./AwardCategoryCard";




const HyvidAwardsTab = () => {
  const [activeTab, setActiveTab] = useState("Nominate");

  const TabLabel = ({ text, icon: Icon }) => {
  return (
    <div className="flex items-center justify-center gap-2">
      <span>{<Icon className="h-4 w-4" />}</span>
      <span className="text-sm font-medium">{text}</span>
    </div>
  );
};
  const tabOptions = [
    {label: <TabLabel icon={Send} text="Nominate" />, value: "Nominate"},
    {label: <TabLabel icon={Sparkles} text="My Nominations" /> ,value: "My Nomination"},
    {label: <TabLabel icon={Trophy} text="Award Winners" />, value: "Award Winners"},
  ];

  return (
    <div className="flex flex-col gap-4">
      <CustomTabs
        tabs={tabOptions}
        height="h-10"
        activeTab={activeTab}
        onChange={setActiveTab}
      />
       
      <div className="mt-3 space-y-4 max-h-[600px] overflow-y-auto">
        {activeTab === "Nominate" &&
        <div className="space-y-6">
          <AwardStatusCard/>
          <AwardCategoryCard/>
        </div>
        }
        
        
      </div>
    </div>
  );
};

export default HyvidAwardsTab;
